import React from 'react';
import { CheckCircle2Icon, MinusCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { afterItems, beforeItems, transformationStats } from '../data/transformation';
export function TransformationSection() {
  return <section className="bg-brand-cream px-4 py-16 md:py-24" data-id="element-178" data-mp="2ww2qsw4bf7xq">
      <Reveal className="mx-auto max-w-[1120px]" data-id="element-179" data-mp="2rzc9y6kos8b9">
        <div className="mx-auto max-w-3xl text-center" data-id="element-180" data-mp="2s0nazymqz1yo">
          <p className="mb-3 text-[11px] font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-181" data-mp="2ny0rqm456pd3">FROM OVERWHELMED TO READY</p>
          <h2 className="text-3xl font-black leading-[1.1] tracking-tight text-brand-blue md:text-[2.75rem]" data-id="element-182" data-mp="2j4o5ujqukwo1">
            From Last-Minute Planning to{' '}
            <span className="italic text-brand-orange" data-id="element-183" data-mp="298l4hg3tl225">Confident, Organized PE Classes</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-brand-gray" data-id="element-184" data-mp="249i07xvnyzv8">
            You did not become a PE teacher to spend Sunday nights searching through dozens of websites. Physical
            Education Ready gives you a clear system, practical activities, and a progression you can follow throughout
            the school year.
          </p>
        </div>
        <div className="mx-auto my-10 grid max-w-3xl divide-y divide-brand-dark overflow-hidden rounded-2xl border border-brand-dark bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0 md:my-12" data-id="element-185" data-mp="5d6a4jz9r8i6">
          {transformationStats.map(([value, label]) => <div key={label} className="px-5 py-5 text-center" data-id="element-186" data-mp="xzh9jrb533de">
              <strong className="block font-serif text-3xl leading-none text-brand-orange" data-id="element-187" data-mp="12zlsrp3fmc7b">{value}</strong>
              <span className="mt-2 block text-[10px] font-extrabold leading-tight tracking-[0.1em] text-brand-gray" data-id="element-188" data-mp="p03zoxj3scs5">
                {label}
              </span>
            </div>)}
        </div>
        <div className="overflow-hidden rounded-3xl border border-brand-dark bg-brand-alt shadow-[0_16px_40px_rgba(18,58,99,0.09)]" data-id="element-189" data-mp="39pjk9arqb59c">
          <div className="grid md:grid-cols-2" data-id="element-190" data-mp="3dqda49oqeu4v">
            <Comparison title="WITHOUT PE READY" items={beforeItems} positive={false} data-id="element-191" data-mp="1k8xt7czi1es2" />
            <Comparison title="WITH PE READY" items={afterItems} positive data-id="element-192" data-mp="1famjr3d496ad" />
          </div>
          <div className="border-t border-brand-dark bg-brand-main px-6 py-4 text-center text-xs font-semibold text-brand-gray" data-id="element-193" data-mp="1ajnxln5g5dz7">
            One organized system for Elementary and Secondary PE — so you prepare less and teach with more confidence.
          </div>
        </div>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckCircle2Icon : MinusCircleIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'border-t border-brand-dark bg-brand-alt md:border-l md:border-t-0' : 'bg-[#F4EFE6]'}`} data-id="element-194" data-mp="mmgxudabtb8y">
      <div className="mb-6 flex items-start justify-between gap-4" data-id="element-195" data-mp="2lyt4z4giw0p5">
        <div data-id="element-196" data-mp="2h000u2n4lm1n">
          <p className={`text-[10px] font-extrabold tracking-[0.16em] ${positive ? 'text-brand-teal' : 'text-brand-gray'}`} data-id="element-197" data-mp="2h1b1vup6sfp2">
            {positive ? 'THE READY-TO-TEACH SYSTEM' : 'THE CURRENT WAY OF PLANNING PE'}
          </p>
          <h3 className="mt-2 font-serif text-2xl font-bold tracking-tight text-brand-blue" data-id="element-198" data-mp="2tghmjfu3muk1">{title}</h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-teal text-white shadow-md' : 'bg-brand-alt text-brand-gray'}`} data-id="element-199" data-mp="338dtzhi2rx0x">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-200" data-mp="2ajq2h46qgbex" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-201" data-mp="2alt1uetrzgwb">
        {items.map(item => <li key={item} className={`flex items-start gap-3 rounded-xl px-3 py-3 ${positive ? 'bg-brand-main' : 'bg-brand-alt/70'}`} data-id="element-202" data-mp="2fhhx45yribmt">
            <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${positive ? 'text-brand-teal' : 'text-brand-gray'}`} aria-hidden="true" data-id="element-203" data-mp="3qz17ciarfeuv" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-204" data-mp="18ovdst03k86b">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}